import {
  TimelineTypeEnum,
  TimelineLeftBoundaryEnum,
  TimelineRightBoundaryEnum,
} from "enums/administration-screens";

export const DEFAULT_TIMELINE_TYPE = TimelineTypeEnum.HORIZONTAL;
export const DEFAULT_TIMELINE_BG_TRANSPARENCY = 100;
export const DEFAULT_TIMELINE_COLOR = "#000000";
export const DEFAULT_TIMELINE_THICKNESS = 4;

export const DEFAULT_TIMELINE_LEFT_BOUNDARY = TimelineLeftBoundaryEnum.DOT;
export const DEFAULT_TIMELINE_RIGHT_BOUNDARY = TimelineRightBoundaryEnum.ARROW;
